import {
  Box,
  Divider,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  VStack,
} from '@chakra-ui/react';
import { Button, StickyToolbar } from 'Atoms';
import { Dispatch, SetStateAction } from 'react';
import { Typography } from 'Tokens';
import { EditIcon } from 'Tokens/Icons/Data';
import { Metric } from '../../MaterialityAssessment.d';
import { MetricMaterialityState } from '../DoubleMaterialityAssessment.d';
import { MetricsMaterialityTableMetric } from './DrMateriality';

export const MaterialityToolbar = ({
  setSelectedMetricsToUpdate,
  selectedMetricsToUpdate,
  handleUpdateMateriality,
  setMutateMetrics,
  materialityOptions,
}: {
  setSelectedMetricsToUpdate: Dispatch<SetStateAction<MetricsMaterialityTableMetric[]>>;
  selectedMetricsToUpdate: MetricsMaterialityTableMetric[];
  handleUpdateMateriality: (
    selection: MetricMaterialityState,
    metric: Metric,
    isChild?: boolean
  ) => void;
  setMutateMetrics: Dispatch<SetStateAction<boolean>>;
  materialityOptions: { value: MetricMaterialityState; label: string }[];
}) => {
  return (
    <StickyToolbar
      onClick={() => {}}
      count={selectedMetricsToUpdate.length}
      onClose={() => setSelectedMetricsToUpdate([])}
      actionText=""
      actionIcon={<></>}
      actionButton={
        <>
          <Divider
            orientation="vertical"
            border="2px"
            borderRadius="3px"
            height="20px"
            borderColor="border.onAccent"
            backgroundColor="border.onAccent"
            marginLeft={'16px'}
          />
          <Popover placement="top">
            <PopoverTrigger>
              <Button
                leftIcon={<EditIcon color={'inherit'} />}
                color="text.onAccent"
                variant="ghost"
                size="sm"
              >
                Change Materiality
              </Button>
            </PopoverTrigger>
            <Portal>
              <PopoverContent width={'243px'} bottom={'10px'}>
                <PopoverHeader borderBottom={'none'} padding={'16px 16px 8px 16px'}>
                  <Typography variant="detail">Change materiality</Typography>
                </PopoverHeader>
                <PopoverBody padding={'0px 8px 10px 8px'}>
                  <VStack>
                    {materialityOptions.map((opt) => {
                      if (opt.value === MetricMaterialityState.phasedIn) {
                        return (
                          <VStack gap={'0px'}>
                            <Box
                              alignSelf={'flex-start'}
                              cursor={'pointer'}
                              _hover={{ bg: 'bg.hover' }}
                              width={'100%'}
                              padding={'6px 8px'}
                              borderRadius={'8px'}
                              onClick={() => {
                                selectedMetricsToUpdate.forEach((met) => {
                                  if (
                                    met.metricOptions.find((option) => option.value === opt.value)
                                  ) {
                                    handleUpdateMateriality(opt.value, met);
                                  }
                                });
                                setSelectedMetricsToUpdate([]);
                                setMutateMetrics(true);
                              }}
                            >
                              <Typography alignSelf={'flex-start'} variant="bodyStrong">
                                {opt.label}
                              </Typography>
                            </Box>
                            <Typography
                              alignSelf={'flex-start'}
                              variant="detail"
                              padding={'0px 8px 6px 8px'}
                            >
                              "Material, but phased in" will only be applied to phased-in data
                              points
                            </Typography>
                          </VStack>
                        );
                      }
                      return (
                        <Box
                          alignSelf={'flex-start'}
                          cursor={'pointer'}
                          _hover={{ bg: 'bg.hover' }}
                          width={'100%'}
                          padding={'6px 8px'}
                          borderRadius={'8px'}
                          onClick={() => {
                            selectedMetricsToUpdate.forEach((met) => {
                              if (met.metricOptions.find((option) => option.value === opt.value)) {
                                handleUpdateMateriality(opt.value, met);
                              }
                            });
                            setSelectedMetricsToUpdate([]);
                            setMutateMetrics(true);
                          }}
                        >
                          <Typography variant="bodyStrong">{opt.label}</Typography>
                        </Box>
                      );
                    })}
                  </VStack>
                </PopoverBody>
              </PopoverContent>
            </Portal>
          </Popover>
        </>
      }
      text={`data point${selectedMetricsToUpdate.length > 1 ? 's' : ''} selected`}
      width="auto"
    />
  );
};
